import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/gold-tier-badge-icon.svg'
import _imports_1 from '../../assets/img/arrow-circle-right-icon.png'


const _hoisted_1 = {
  key: 0,
  class: "premium-reward-section"
}
const _hoisted_2 = { class: "premium-reward-title-group" }
const _hoisted_3 = { class: "premium-reward-title-name" }
const _hoisted_4 = { class: "arrow" }
const _hoisted_5 = { class: "premium-reward-items" }
const _hoisted_6 = { class: "premium-reward-detail-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "gold-tier"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "gold-tier-badge",
  src: _imports_0
}, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "premium-reward-section"
}
const _hoisted_13 = { class: "premium-reward-title-group" }
const _hoisted_14 = { class: "premium-reward-title-name" }
const _hoisted_15 = { class: "arrow" }
const _hoisted_16 = { class: "premium-reward-items" }
const _hoisted_17 = { class: "premium-reward-detail-img" }
const _hoisted_18 = { class: "premium-reward-detail-group" }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_q_skeleton = _resolveComponent("q-skeleton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoading && _ctx.offersList.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(_ctx.textTitleName), 1)
            ]),
            _createElementVNode("div", {
              class: "premium-reward-title-view-all",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.openModalOffer()))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.textViewAll), 1),
              _createElementVNode("button", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_swiper, {
              slidesPerView: 'auto',
              spaceBetween: 12,
              freeMode: true,
              modules: _ctx.modules
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offersList, (offer, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (index < 10)
                      ? (_openBlock(), _createBlock(_component_swiper_slide, {
                          key: 0,
                          class: "premium-reward-slide",
                          onClick: $event => (_ctx.openModalOffer(offer))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("img", {
                                src: _ctx.getImage(offer.offerDetails.media.url),
                                onError: _cache[1] || (_cache[1] = (...args) => (_ctx.errorImage && _ctx.errorImage(...args)))
                              }, null, 40, _hoisted_7)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["premium-reward-detail-group", { 'gold-tier-group': offer.offerDetails?.offerType?.toLocaleLowerCase().includes('gold') }])
                            }, [
                              (offer.offerDetails?.offerType?.toLocaleLowerCase().includes('gold'))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                    _hoisted_9,
                                    _createTextVNode(_toDisplayString(offer.offerDetails.title), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(offer.offerDetails.title), 1))
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256)),
                (_ctx.offersList.length >= 10)
                  ? (_openBlock(), _createBlock(_component_swiper_slide, {
                      key: 0,
                      class: "premium-reward-slide-view-all",
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.openModalOffer()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createElementVNode("span", null, _toDisplayString(_ctx.textViewAll), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modules"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_ctx.textTitleName), 1)
            ]),
            _createElementVNode("div", {
              class: "premium-reward-title-view-all",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.openModalOffer()))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.textViewAll), 1),
              _createElementVNode("button", _hoisted_15, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_swiper, {
              slidesPerView: 'auto',
              spaceBetween: 12,
              freeMode: true,
              modules: _ctx.modules
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
                  return _createVNode(_component_swiper_slide, { class: "premium-reward-slide" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_q_skeleton, {
                          class: "skeleton-img",
                          width: "24.53vw",
                          height: "24.53vw"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_q_skeleton, {
                          class: "skeleton-title",
                          width: "15.73vw",
                          height: "3.73vw"
                        })
                      ])
                    ]),
                    _: 1
                  })
                }), 64))
              ]),
              _: 1
            }, 8, ["modules"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}